import { ref, computed, defineAsyncComponent } from 'vue';

export function useDevLinks() {
  const showComponentName = ref(false);

  const devLinksComponent = computed(() => defineAsyncComponent(() => import('@/components/devLinks/DevLinks')));

  return {
    showComponentName,
    devLinksComponent,
  };
}

export default useDevLinks;
